// extracted by mini-css-extract-plugin
module.exports = {"Plugins":"Page_Plugins__1UyAw","Container":"Page_Container__hjfUj","TableHeader":"Page_TableHeader__150Fu"};